import React, { Fragment } from 'react';
import styles from '../../index.less';
import { MarkInfoItemType, TabItemType } from '../../types';
import { maxSeconds } from '../../utils';
import CountDown from './countDown';

function CountDownBar(props: {
  data: MarkInfoItemType;
  endMsg: string;
  seconds: number;
  onTimeEnd: () => void;
  tabBgColor?: string;
}) {
  const { data, endMsg, seconds, onTimeEnd, tabBgColor } = props;
  return (
    <div style={{ background: tabBgColor }} className={styles['count-down-wrapper']}>
      {seconds <= maxSeconds && (
        <Fragment>
          <div className={styles['end-msg-wrapper']}>{endMsg}</div>
          <CountDown seconds={seconds} onTimeEnd={onTimeEnd} />
        </Fragment>
      )}
    </div>
  );
}

export default CountDownBar;
